import dashboard from './dashboard';
import pages from './pages';
import utilities from './utilities';
import other from './other';
import ReceiptIcon from '@mui/icons-material/Receipt';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import FactCheckIcon from '@mui/icons-material/FactCheck';
// ==============================|| MENU ITEMS ||============================== //

// const menuItems = {
//     items: [dashboard, pages, utilities, other]
// };

const utilities2 = {
    id: 'Lists',
    title: 'Lists',
    type: 'group',
    children: [
        {
            id: 'EssayList',
            title: 'Essay List',
            type: 'item',
            url: '/MyHussain/EssayList',
            icon: FactCheckIcon,
            breadcrumbs: false
        },
        {
            id: 'QuizList',
            title: 'Quiz List',
            type: 'item',
            url: '/MyHussain/QuizList',
            icon: FactCheckIcon,
            breadcrumbs: false
        },

    ]
};

const utilities3 = {
    id: 'Lists',
    title: 'Lists',
    type: 'group',
    children: [
        {
            id: 'EssayList',
            title: 'Essay List',
            type: 'item',
            url: '/MyHussain/EssayList',
            icon: FactCheckIcon,
            breadcrumbs: false
        },
        {
            id: 'QuizList',
            title: 'Quiz List',
            type: 'item',
            url: '/MyHussain/QuizList',
            icon: FactCheckIcon,
            breadcrumbs: false
        },

    ]
};

const menuItems = {
    items: [dashboard, utilities,utilities2,other,pages,utilities3]
};


export default menuItems;
